import { combineReducers } from 'redux';

import access from './access';
import profile from './profile';
import orgUser from './orgUser';

export default combineReducers({
  access,
  profile,
  orgUser,
});
